import AddToCart from "@/front/components/product/ProdutPackAddToCart";
import Vue from "vue";

Vue.prototype.$api = window.$api;

new Vue({
  el:'#product-pack-add-to-cart',
  render: h => h(AddToCart)
})
